export default __webpack_public_path__ + "static/media/Pipeline work.1800f7d0.jpg";